import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient} from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class WorkFormItemService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getWorkFormItems(): Observable<any> {
    return this.http.get(environment.apiUrl + '/backoffice/work-form-item/')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public showWorkFormItem(id): Observable<any> {
    return this.http.get(environment.apiUrl + '/backoffice/work-form-item/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public createWorkFormItem(data) {
    return this.http.post(environment.apiUrl + '/backoffice/work-form-item/', data)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public updateWorkFormItem(data, id) {
    return this.http.put(environment.apiUrl + '/backoffice/work-form-item/' + id, data)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  removeWorkFormItem(id) {
    return this.http.delete(environment.apiUrl + '/backoffice/work-form-item/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
